export const SET_DRAWER_OPEN = "state/ui/SET_DRAWER_OPEN";
export const SET_MODAL = "state/ui/SET_MODAL";
export const SET_SMALL_DEVICE = "state/ui/SET_SMALL_DEVICE";
export const SET_SNACKBAR = "state/ui/SET_SNACKBAR";
